export default function(
  eventName,
  payload,
  category = 'usertracking',
  version = 'v3'
) {
  if (window.tagular) {
    window.tagular('beam', eventName, {
      '@type': `redventures.${category}.${version}.${eventName}`,
      ...payload
    })
  }
}

export function beamPageLoad(
  eventName,
  payload,
  category = 'usertracking',
  version = 'v3'
) {
  if (window.tagular) {
    window.tagular('beam', {
      '@type': `redventures.${category}.${version}.${eventName}`,
      ...payload
    })
  }
}
